import React, {Component} from 'react';
import {connect} from 'react-redux';
import SocialMedia from '../../../Shared/components/Contact/SocialMedia';
import ProtectoraImagesVideosDetail from './ProtectoraImagesVideosDetail';
import {
    loadInfoProtectoraDetail,
    modeEmail,
    resetShowVideoProtectora,
    showImagenVideoProtectora
} from '../../../AnimalList/actions/actionsAnimalList';
import {
    resetInfoAnimalDetail,
} from '../../../Animal/actions/actionsAnimal';
import Contact from '../../../Shared/components/Contact/OLD_Contact';
import ContactByEmail from '../../../AnimalList/components/ListCards/cards/old_CardListingContactByEmail';
import {browserHistory} from 'react-router';
import {checkIsLogin} from '../../../AdminProtectora/actions/actionsAdmin';

import ShareButtonsBox from '../../../Shared/components/SocialMediaButtons/ShareButtonsBox'
import {
    PATH_ADOPTAR,
    PATH_BUSCADOR_ANIMALES_ADMIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO,
    PATH_PROTECTORA_ID
} from "../../../../App/RouterAdopta";
import TeamingButton from "../../../Shared/components/Contact/TeamingButton";
import Descripcion from "../../../Shared/components/components/Descripcion/Descripcion";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../../analytics/config/analyticsParamsFrontEnd";


class OldProtectoraDetail extends Component {

    constructor(props) {
        super(props);
        this.props.isLogin();

        this.state = {
            idProtectora: this.props.idProtectora
        }

        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoProtectora",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Alguna pregunta?"],
            messageWhatsapp: "Hola%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20vosotros%20",
            idSelect: "contactoProtectora",
            divSelect: '.divSelectContactoProtectora',
            tipo: 'protectora'
        };

        //Config información
        this.configInformation = {
            titleHead: "Redes Sociales",
            socials: [
                {
                    url: this.props.infoProtectoraDetail.facebook && this.props.infoProtectoraDetail.facebook.url ? this.props.infoProtectoraDetail.facebook.url : '',
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: this.props.infoProtectoraDetail.twitter && this.props.infoProtectoraDetail.twitter.url ? this.props.infoProtectoraDetail.twitter.url : '',
                    socialIcon: "lab la-twitter"
                },
                {
                    url: this.props.infoProtectoraDetail.instagram && this.props.infoProtectoraDetail.instagram.url ? this.props.infoProtectoraDetail.instagram.url : '',
                    socialIcon: "lab la-instagram"
                }
            ]
        };

        this.showImagenVideo = this.showImagenVideo.bind(this);
        this.hideDetail = this.hideDetail.bind(this);
        this.hideEmailContact = this.hideEmailContact.bind(this);
        this.backSearch = this.backSearch.bind(this);
        this.backToHall = this.backToHall.bind(this);
        this.insertAnimal = this.insertAnimal.bind(this);
        this.clickLinkDescripcion = this.clickLinkDescripcion.bind(this);
        this.clickLinkTeamingDescripcion = this.clickLinkTeamingDescripcion.bind(this);
        this.clickEmailDescripcion = this.clickEmailDescripcion.bind(this);
    }

    showImagenVideo() {
        if (this.props.showProtectora) {
            $('#showImagesVideoProtectora').text("Ver fotos");
        } else {
            $('#showImagesVideoProtectora').text("Ocultar fotos");
        }
        this.props.showImagenVideoProtectora();
    }

    hideDetail() {
    }

    hideEmailContact() {
        this.props.modeEmail(false, this.props.animalsControl);
    }

    changeModeEmail(mode,animalsControl) {
        this.props.modeEmail(mode, animalsControl);
    }



    backSearch() {
        browserHistory.push(PATH_ADOPTAR);
    }

    backToHall() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
    }

    insertAnimal() {
        // var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        // $('#animals-list-container').removeClass("fadeIn").addClass('fadeOut');
        // $('.card-detail-protectora').removeClass("fadeIn").addClass('fadeOut');
        // $('.protectora-detail__heading').removeClass("fadeIn").addClass('animated-400ms fadeOut');

        // var width = window.innerWidth;

        this.props.resetInfoAnimalDetail("animalsProtectora");

        // if (width < 992) {
        //     $('.icon-wrapper').removeClass('animated-500ms fadeInLeft').addClass('animated-500ms fadeOutLeft').one(animationEnd, function () {
        //         browserHistory.push('/buscador/admin/animal/nuevo');
        //     });
        // } else {
        //     $('#animals-filter').removeClass('fadeInLeft').addClass('fadeOutLeft').one(animationEnd, function () {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO);
        // });
        // }
    }


    clickLinkDescripcion() {
        //console.log("CardInfoDetailProtectora::clickLinkDescripcion()");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.LINK_DESCRIPCION, {id_protectora: this.props.infoProtectoraDetail._id});
    }

    clickLinkTeamingDescripcion() {
        //console.log("CardInfoDetailProtectora::clickLinkTeamingDescripcion()");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.TEAMING_BUTTON, {id_protectora: this.props.infoProtectoraDetail._id});
    }

    clickEmailDescripcion() {
        //console.log("CardInfoDetailProtectora::clickEmail()");
        this.props.modeEmail(true, this.props.animalsControl);
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.EMAIL_DESCRIPCION, {id_protectora: this.props.infoProtectoraDetail._id});
    }


    render() {
        let showInfo = false;
        let eventBack;
        let textBack;
        if (this.props.admin.isLogin && this.props.admin.id === this.props.idProtectora && this.props.adminAnimals) {
            eventBack = this.backToHall;
            textBack = "Volver al panel";
        } else {
            eventBack = this.backSearch;
            textBack = "Volver a la búsqueda";
        }

        let animalsControlPlus;
        let classSource = "";
        let direccion;
        let {img_principal} = this.props.infoProtectoraDetail;
        if (Object.keys(this.props.infoProtectoraDetail).length !== 0 && this.props.infoProtectoraDetail._id !== undefined && !this.props.modeEmail_2) {
            showInfo = true;

            const direccionObj = this.props.infoProtectoraDetail.direccion;
            animalsControlPlus = (this.props.animalsControl + "2");
            if (direccionObj && direccionObj.ocultar_direccion_exacta) {
                direccion = "Zona de " + direccionObj.municipio + ", " + direccionObj.provincia;
            } else if (direccionObj && !direccionObj.ocultar_direccion_exacta && direccionObj.calle && direccionObj.numero) {
                direccion = direccionObj.calle + ", " + direccionObj.numero + ", " + direccionObj.municipio + ", " + direccionObj.provincia
            } else {
                direccion = direccionObj.municipio + " (" + direccionObj.provincia + ")"
            }

            if (!img_principal || !img_principal.url) {
                img_principal = {
                    url: process.env.CDN_URL+'/images/adoptaunanimal/default/protectora2.png'
                }
            }
        }
        const teaming = this.props.infoProtectoraDetail.teaming && this.props.infoProtectoraDetail.teaming.url && this.props.infoProtectoraDetail.teaming.nick ? this.props.infoProtectoraDetail.teaming : undefined;
        let url;
        try {
            url = (this.props.infoProtectoraDetail.URL) ? this.props.infoProtectoraDetail.URL.replace("https://", "").replace("http://", "").replace("www.", "").split("/").shift() : undefined;
        } catch (e) {
            console.error(e)
            url = this.props.infoProtectoraDetail.URL
        }
        return (
            <div className="row">
                <div className="card-block card-detail-protectora">
                    {showInfo &&
                    <div className="cardInfoDetailShow">
                        <div className="informationDetailDescriptionUp">
                            <div className="informationDetailDescriptionUpLeft_noHidenResponsive">
                                <LazyLoadImage threshold={150} src={img_principal.url} alt=""
                                     className="embed-responsive"/>
                            </div>
                            <div className="informationDetailDescriptionUpRight informationDetailProtectora">
                                <h4 className="card-title">{this.props.infoProtectoraDetail.nombre}</h4>
                                <div className="informationDetailProtectora__row">
                                    <div className="informationDetailProtectora__column">
                                        {/*<div className="informationDetailProtectora__content_row">*/}
                                        {/*    <span className="las la-envelope informationDetailProtectora__icon"></span>*/}
                                        {/*    <span className="email informationDetailProtectora__text">Email: </span>*/}
                                        {/*    <span*/}
                                        {/*        className="email-data informationDetailProtectora__text">{this.props.infoProtectoraDetail.email}</span>*/}
                                        {/*</div>*/}
                                        {/*<div className="informationDetailProtectora__content_row">*/}
                                        {/*    <span className="las la-phone informationDetailProtectora__icon"></span>*/}
                                        {/*    <span*/}
                                        {/*        className="telefono informationDetailProtectora__text">Teléfono: </span>*/}
                                        {/*    <span*/}
                                        {/*        className="telefono-data informationDetailProtectora__text">{(this.props.infoProtectoraDetail.colaboradores) ? this.props.infoProtectoraDetail.colaboradores.map((el) => {*/}
                                        {/*        return el.telefono*/}
                                        {/*    }).toString() : " - "}</span>*/}
                                        {/*</div>*/}
                                        <div className="informationDetailProtectora__content_row">
                                            <span
                                                className="las la-map-marker-alt informationDetailProtectora__icon"></span>
                                            <span
                                                className="direccion informationDetailProtectora__text">Dirección: </span>
                                            <span
                                                className="direccion-data informationDetailProtectora__text">{direccion}</span>
                                        </div>
                                    </div>
                                    <div className="informationDetailProtectora__content_row">
                                            <span
                                                className="las la-shipping-fast informationDetailProtectora__icon"></span>
                                        <span className="realizaEnvios informationDetailProtectora__text"> Realiza envio: </span>
                                        <span
                                            className="realizaEnvio-data informationDetailProtectora__text">{(this.props.infoProtectoraDetail.realiza_envios ? "Si" : "No")}</span>
                                    </div>
                                    <div className="informationDetailProtectora__content_row">
                                            <span
                                                className="las la-globe-europe informationDetailProtectora__icon"></span>
                                        <span className="web informationDetailProtectora__text"> Página web: </span>
                                        {url
                                            ? <a href={url} target='_blank'
                                                 className="web-data informationDetailProtectora__text">{url}</a>
                                            :
                                            <span
                                                className="web-data informationDetailProtectora__text">sin página web</span>
                                        }
                                    </div>
                                    <div className="informationDetailProtectora__column">
                                        <div className="informationDetailProtectora__content_row">
                                            <span className="las la-question informationDetailProtectora__icon"></span>
                                            <span className="estado informationDetailProtectora__text"> Estado: </span>
                                            <span
                                                className="estado-data informationDetailProtectora__text">{this.props.infoProtectoraDetail.estado}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="informationDetailProtectora__row-100">
                                    {/*<div className="infoDetailProOneColumn">*/}
                                    {/*    <a onClick={this.showImagenVideo} href="#" id="showImagesVideoProtectora" className="btn btn-outdivne-primary listing-houses__item-view-link">Ver fotos</a>*/}
                                    {/*</div>*/}
                                    <div className="div-rrss-contacto-protectora">
                                        <div className="social-media-block">
                                            <SocialMedia
                                                configInformation={this.configInformation}
                                                animalsControl={this.props.animalsControl}
                                                animalsControlDetail={this.props.animalsControlDetail}
                                            />
                                        </div>
                                        <div className="contacto-block">
                                            <Contact
                                                urlWhastapp={process.env.HOST_ADOPTA + PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                                configEstadoContacto={this.configEstadoContacto}
                                                animalsControl={this.props.animalsControl}
                                                animalsControlDetail={this.props.animalsControlDetail}
                                                changeModeEmail={this.changeModeEmail}
                                            />
                                        </div>
                                    </div>
                                    {/*{this.props.showProtectora &&*/}
                                    {/*    <ProtectoraImagesVideosDetail*/}
                                    {/*        idProtectora={this.props.idProtectora}*/}
                                    {/*    />*/}
                                    {/*}*/}
                                    {teaming &&
                                    <div>
                                        <h5>Donaciones</h5>
                                        <TeamingButton
                                            id={this.props.infoProtectoraDetail._id}
                                            nombre={this.props.infoProtectoraDetail.nombre}
                                            teaming={teaming}
                                        />
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <Descripcion
                            descripcion={this.props.infoProtectoraDetail.descripcion}
                            onClickLink={this.clickLinkDescripcion}
                            onClickLinkTeaming={this.clickLinkTeamingDescripcion}
                            onClickEmail={this.clickEmailDescripcion}
                        />
                    </div>
                    }
                    {this.props.modeEmail_2 &&
                    <div id="selCard" className="cardInfoDetailShow">
                        <div className="block_card"></div>
                        <div className="card-header">
                            <h5 className="card-title-email">Contacto por email</h5>
                            <button type="button" className="close closeDetail" onClick={this.hideEmailContact}
                                    data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div>
                            <ContactByEmail
                                source={"protectora"}
                                classSource={classSource}
                                animalsControl={this.props.animalsControl}
                                animalsControlDetail={this.props.animalsControlDetail}
                                ok_shadow={"card-block"}
                            />
                        </div>
                        <a onClick={this.hideEmailContact} href="#" id="btn_close_detail"
                           className="btn btn-outline-primary listing-houses__item-view-link">Cerrar</a>
                    </div>
                    }
                    <div className="infoContactProtectora text-left">
                        <div className="moreProtectoraInfo">
                            <h4>Compartir</h4>
                            <ShareButtonsBox
                                shareURL={process.env.HOST_ADOPTA + PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                text={""}
                                hashtags={["AdoptaNoCompres"]}
                            />
                        </div>
                    </div>
                    <div className="imagenesProtectora borde-superior">
                        <h5 className="card-title">Fotos de {this.props.infoProtectoraDetail.nombre}</h5>
                        <ProtectoraImagesVideosDetail
                            idProtectora={this.props.idProtectora}
                        />
                        {/*<div className="infoDetailProOneColumn">*/}
                        {/*    <a onClick={this.showImagenVideo} href="#" id="showImagesVideoProtectora" className="btn btn-outdivne-primary listing-houses__item-view-link">Ver fotos</a>*/}
                        {/*</div>*/}
                        {/*{this.props.showProtectora &&*/}
                        {/*    <ProtectoraImagesVideosDetail*/}
                        {/*        idProtectora={this.props.idProtectora}*/}
                        {/*    />*/}
                        {/*}*/}
                    </div>
                    <div className="borde-superior botonera-protectora-detail">
                        <a onClick={eventBack} href="#" id="btn_back_search"
                           className="btn btn-outline-primary listing-houses__item-view-link">{textBack}</a>
                        {this.props.admin.isLogin && this.props.admin.id === this.props.idProtectora && this.props.isAdminAnimals &&
                        <a onClick={this.insertAnimal} href="#" id="btn_back_search"
                           className="btn btn-outline-primary listing-houses__item-view-link">Añadir animal</a>
                        }

                    </div>
                </div>
            </div>
        );
    }

    componentWillMount() {
        // if (this.props.route.path.startsWith('/buscador/admin/adminAnimal')) {

        // if (!this.props.admin.isLogin) {
        //     console.log("No login -> /login");
        //     return browserHistory.push("/login")
        // } else if (this.props.admin.id !== this.props.idProtectora) {
        //     console.log("admin=" + this.props.admin.id + " !== params=" + this.props.idProtectora + " -> /buscador/admin/adminAnimals/" + this.props.admin.id);
        //     return browserHistory.push("/buscador/admin/adminAnimals/" + this.props.admin.id)
        // } else {


        this.props.resetShowVideoProtectora();
        this.props.loadInfoProtectoraDetail(this.props.idProtectora, this.props.animalsControl, "completa");
        this.props.modeEmail(false, this.props.animalsControl);
        // }
        // }
    }

    componentDidMount() {
        // var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        // let that = this;
        // $('.card-detail-protectora').addClass("animated-5s fadeIn").one(animationEnd, function () {
        // if (Object.keys(that.props.infoProtectoraDetail).length === 0) {
        //$('.card-detail-protectora').addClass("blink")
        // }
        // });

        //var nav = $('.card-detail-protectora');

        //var animateTime = 20;

        // $(window).on('resize', function(){
        //     that.autoHeightAnimate(nav, animateTime);
        // });

    }

    componentDidUpdate() {
        //var nav = $('.card-detail-protectora');
        // var animateTime = 20;
        // this.autoHeightAnimate(nav, animateTime);
    }

    // autoHeightAnimate(element, time) {
    //     console.log("EntityProtectoraDetail::autoHeightAnimate()");
    //     var curHeight = element.height(); // Get Default Height
    //     var autoHeight = element.css('height', 'auto').height() + 40; // Get Auto Height
    //     element.height(curHeight); // Reset to Default Height
    //     element.stop().animate({height: autoHeight}, time); // Animate to Auto Height
    // }
}

function mapStateToProps(state, ownProps) {
    return {
        infoProtectoraDetail: state[ownProps.animalsControlDetail].infoProtectoraDetail,
        showProtectora: state.animalDetailProtectoraImagenYVideo.show,
        modeEmail_2: state[ownProps.animalsControlDetail].modeEmail_2,
        admin: state.access
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    loadInfoProtectoraDetail,
    showImagenVideoProtectora,
    resetShowVideoProtectora,
    modeEmail,
    resetInfoAnimalDetail,
    isLogin: checkIsLogin
})(OldProtectoraDetail)
